module.exports = __webpack_public_path__ + "static/media/team-5.b1cb7bc5.avif";